function _typeof(o) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, 'string');
    return 'symbol' == _typeof(i) ? i : i + '';
}
function _toPrimitive(t, r) {
    if ('object' != _typeof(t) || !t)
        return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != _typeof(i))
            return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return ('string' === r ? String : Number)(t);
}
import Promise from 'promise-polyfill';
import { isMobile } from './utils';
import handleOption from './options';
import i18n from './i18n';
import Template from './template';
import SvgCollection from './svg';
import Events from './events';
import FullScreen from './fullscreen';
import User from './user';
import Bar from './bar';
import Bezel from './bezel';
import Controller from './controller';
import Setting from './setting';
import HotKey from './hotkey';
import ContextMenu from './contextmenu';
import servers from './servers/index';
var index = 0;
var instances = [];
var LinePlayer = function () {
    function LinePlayer(options) {
        var _this = this;
        _classCallCheck(this, LinePlayer);
        this.options = handleOption(options);
        this.tran = new i18n(this.options.lang).tran;
        this.icons = new SvgCollection(this.options);
        this.events = new Events();
        this.user = new User(this);
        this.container = this.options.container;
        this.cameras = this.options.cameras;
        this.container.classList.add('lineplayer');
        if (this.options.live) {
            this.container.classList.add('lineplayer-live');
        }
        if (isMobile) {
            this.container.classList.add('lineplayer-mobile');
        }
        this.arrow = this.container.offsetWidth <= 500;
        if (this.arrow) {
            this.container.classList.add('lineplayer-arrow');
        }
        this.template = new Template({
            container: this.container,
            options: this.options,
            index: index,
            tran: this.tran,
            icons: this.icons
        });
        this.video = this.template.video;
        this.bar = new Bar(this);
        this.bezel = new Bezel(this.template.bezel);
        this.fullScreen = new FullScreen(this);
        this.controller = new Controller(this);
        this.setting = new Setting(this);
        document.addEventListener('click', function () {
            _this.focus = false;
        }, true);
        this.container.addEventListener('click', function () {
            _this.focus = true;
        }, true);
        this.paused = true;
        this.hotkey = new HotKey(this);
        this.contextmenu = new ContextMenu(this);
        this.initVideoEvents(this.video);
        var played = false;
        servers.types.forEach(function (type) {
            if (_this.options[type]) {
                _this.options[type] = [_this.options[type] || []].reduce(function (flat, current) {
                    return flat.concat(current);
                }, []);
                _this.options[type].forEach(function (server) {
                    servers.load(type, server).then(function (cameras) {
                        _this.cameras = _this.cameras.concat(cameras);
                        if (_this.cameras.length > 0 && !played) {
                            played = true;
                            setTimeout(function () {
                                _this.switchVideo(0);
                                if (_this.options.autoplay && !isMobile) {
                                    _this.play();
                                } else if (isMobile) {
                                    _this.pause();
                                }
                            }, 0);
                        }
                    });
                });
            }
        });
        this.events && this.events.trigger('lineserver_load_end');
        index++;
        instances.push(this);
    }
    return _createClass(LinePlayer, [
        {
            key: 'initVideoEvents',
            value: function initVideoEvents() {
                var _this2 = this;
                this.on('error', function () {
                    _this2.tran && _this2.notice && _this2.notice(_this2.tran('This video fails to load'), -1);
                });
                this.on('play', function () {
                    if (_this2.paused) {
                        _this2.play();
                    }
                });
                this.on('pause', function () {
                    if (!_this2.paused) {
                        _this2.pause();
                    }
                });
                this.on('lineserver_load_start', function () {
                    _this2.container.classList.add('lineplayer-loading');
                });
                this.on('lineserver_load_end', function () {
                    _this2.container.classList.remove('lineplayer-loading');
                });
                var _loop = function _loop(i) {
                    _this2.video.addEventListener(_this2.events.videoEvents[i], function () {
                        _this2.events.trigger(_this2.events.videoEvents[i]);
                    });
                };
                for (var i = 0; i < this.events.videoEvents.length; i++) {
                    _loop(i);
                }
                if (this.options.volume) {
                    this.volume(this.user.get('volume'), true, true);
                } else {
                    this.video.muted = true;
                }
            }
        },
        {
            key: 'switchVideo',
            value: function switchVideo(channel) {
                var quality = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                channel = Math.max(0, Math.min(this.cameras.length - 1, channel));
                quality = Math.max(0, Math.min(this.cameras[channel].quality.length - 1, quality));
                if (channel == this.currentChannel && quality == this.currentQuality) {
                    return;
                }
                this.currentChannel = channel;
                this.currentQuality = quality;
                if (Hls && Hls.isSupported()) {
                    var paused = this.video.paused;
                    if (!paused)
                        this.pause();
                    if (this.cameras[channel].image)
                        this.video.poster = this.cameras[channel].image;
                    this.url = this.cameras[channel].quality[quality].url;
                    if (this.cameras[channel].name)
                        this.title(this.cameras[channel].name);
                    this.controller.initQualityButton(this.cameras[channel].quality, quality);
                    if (this.cameras.length > 1) {
                        this.controller.initPrevButton(channel > 0);
                        this.controller.initNextButton(channel < this.cameras.length - 1);
                    }
                    if (!paused)
                        this.play();
                }
            }
        },
        {
            key: 'play',
            value: function play(fromNative) {
                var _this3 = this;
                this.paused = false;
                if (this.video.paused) {
                    this.bezel['switch'](this.icons.get('play'));
                }
                if (Hls && Hls.isSupported()) {
                    this.hls = new Hls();
                    this.hls.loadSource(this.url);
                    this.hls.attachMedia(this.video);
                }
                this.controller.initPlayButton('Pause', 'pause');
                if (!fromNative) {
                    var playedPromise = Promise.resolve(this.video.play());
                    playedPromise['catch'](function () {
                        _this3.pause();
                    }).then(function () {
                    });
                }
                this.container.classList.add('lineplayer-playing');
                this.template.liveBadge.style.display = 'inline-block';
                if (this.options.mutex) {
                    for (var i = 0; i < instances.length; i++) {
                        if (this !== instances[i]) {
                            instances[i].pause();
                        }
                    }
                }
            }
        },
        {
            key: 'pause',
            value: function pause(fromNative) {
                this.paused = true;
                if (!this.video.paused) {
                    this.bezel['switch'](this.icons.get('pause'));
                }
                if (Hls && Hls.isSupported()) {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.video.clientWidth;
                    canvas.height = this.video.clientHeight;
                    canvas.getContext('2d').drawImage(this.video, 0, 0, canvas.width, canvas.height);
                    this.video.poster = canvas.toDataURL();
                    this.hls.stopLoad();
                    this.hls.detachMedia();
                }
                this.controller.initPlayButton('Play', 'play');
                if (!fromNative) {
                    this.video.pause();
                }
                this.container.classList.remove('lineplayer-playing');
                this.template.liveBadge.style.display = 'none';
            }
        },
        {
            key: 'switchVolumeIcon',
            value: function switchVolumeIcon() {
                var volumeIcon = this.template.volume.querySelector('.lineplayer-icon-content');
                if (this.volume() >= 0.95) {
                    volumeIcon.innerHTML = this.icons.get('volume-up');
                } else if (this.volume() > 0) {
                    volumeIcon.innerHTML = this.icons.get('volume-down');
                } else {
                    volumeIcon.innerHTML = this.icons.get('volume-off');
                }
            }
        },
        {
            key: 'volume',
            value: function volume(percentage, nostorage, nonotice) {
                percentage = parseFloat(percentage);
                if (!isNaN(percentage)) {
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    this.bar.set('volume', percentage, 'width');
                    if (!nostorage) {
                        this.user.set('volume', percentage);
                    }
                    if (!nonotice) {
                        this.notice(''.concat(this.tran('Volume'), ' ').concat((percentage * 100).toFixed(0), '%'));
                    }
                    this.video.volume = percentage;
                    if (this.video.muted) {
                        this.video.muted = false;
                    }
                    this.switchVolumeIcon();
                }
                return this.video.volume;
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.video.paused) {
                    this.play();
                } else {
                    this.pause();
                }
            }
        },
        {
            key: 'on',
            value: function on(name, callback) {
                this.events.on(name, callback);
            }
        },
        {
            key: 'notice',
            value: function notice(text) {
                var _this4 = this;
                var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
                var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.8;
                this.template.notice.innerHTML = text;
                this.template.notice.style.opacity = opacity;
                if (this.noticeTime) {
                    clearTimeout(this.noticeTime);
                }
                this.events.trigger('notice_show', text);
                this.noticeTime = setTimeout(function () {
                    _this4.template.notice.style.opacity = 0;
                    _this4.events.trigger('notice_hide');
                }, time);
            }
        },
        {
            key: 'title',
            value: function title(text) {
                if (this.template.title)
                    this.template.title.innerHTML = text;
            }
        },
        {
            key: 'resize',
            value: function resize() {
                this.events.trigger('resize');
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                instances.splice(instances.indexOf(this), 1);
                this.pause();
                this.controller.destroy();
                this.video.src = '';
                this.container.innerHTML = '';
                this.events.trigger('destroy');
                for (var key in this) {
                    if (Object.prototype.hasOwnProperty.call(this, key) && key !== 'paused') {
                        delete this[key];
                    }
                }
            }
        }
    ]);
}();
export default LinePlayer;